import './style.scss';

interface IProps {
    children?: React.ReactNode;
}

export const FooterLayout: React.FC<IProps> = (props) => {
    return <div className="c-footer">{props?.children}</div>;
};
